<h3>Vertriebsgebiet</h3>
<div class="col-sm-6" [formGroup]="form">

  <select class="form-control" id="id_fieldservice"
    formControlName="fieldService"
    [ngClass]="{red_alert: error}">
    <option [ngValue]="null">-- Vertriebsgebiet auswählen --</option>
    @for (field of fieldServices; track field) {
      <option [value]="field.name">{{ field.name }}</option>
    }
  </select>

</div>

<div class="col-sm-6 chrissies">
  @if (fieldServiceUser) {
    <h4 class="padding-top-5">
      - {{ fieldServiceUser.firstName }} {{ fieldServiceUser.lastName }}
    </h4>
  }
</div>
